export const noMarginMixin = (props) => {
  const { 'no-margin': noMargin } = props;
  if (!noMargin) { return null; }
  return 'margin: 0;';
};
